import { Box, TextField, Typography } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import React from "react";
import { sizes } from "../../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "../customerGroupSetupSlice";

export default function CreateComments() {
	const cgState = useSelector((store) => store.customerGroupSetup);
	const { createComments } = cgState;
	const dispatch = useDispatch();

	function updateComments(event) {
		const comment = event.target.value;
		dispatch(setCGState("createComments", comment));
	}

	return (
		<Box>
			{" "}
			{/* <Box sx={{ mt: 4, display: "flex", flexDirection: "row" }}>
				<Typography className="compHeading" sx={{fontWeight: "bold", color: "blue.main", width: "100%"}}>
					Comment
				</Typography>
			</Box>{" "} */}
			<TextField className={'fullHeight'}
						overflow="scroll"
						multiline
						id="outlined-basic"
						label=""
						rows= {6}
						variant="outlined"
						size="large"
						sx={{
							width: 1000,
						}}
				// InputProps={{ sx: { height: sizes.w150 } }}
				value={createComments}
				onChange={updateComments}
				InputProps={{ autoComplete: "off" }}
			/>
		</Box>
	);
}
